import { reportClinicianSearchError } from 'client-portal/utils/clinicianSearch/report-error';
import { tracked } from '@glimmer/tracking';
import Service, { service } from '@ember/service';

export default class ClinicianSearchClinicianDetailsService extends Service {
  @service store;

  @tracked enrichmentVersion = 0;

  #enriched = new Set();

  resetState() {
    this.#enriched.clear();
    this.enrichmentVersion = 0;
  }

  isEnriched(clinicianId) {
    return this.#enriched.has(String(clinicianId));
  }

  async enrich(ids) {
    let unique = [...new Set(ids.map(String).filter(Boolean))];
    if (!unique.length) {
      return;
    }

    try {
      await this.#flush(unique);
    } catch (err) {
      reportClinicianSearchError(err);
    }
  }

  async #flush(ids) {
    let toFetch = ids.filter(id => !this.#enriched.has(String(id)));
    if (!toFetch.length) {
      return;
    }

    await this.store.query('clinician', {
      id: toFetch.map(id => String(id)),
      filter: { includeAll: true },
    });

    for (let id of toFetch) {
      this.#enriched.add(String(id));
    }
    this.enrichmentVersion += 1;
  }
}
